var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartEventCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2048,
    width: 2048,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1024 99.003906c-510.27067 0-925 414.720644-925 924.994094 0 510.2736 414.72866 925.004 925 925.004 510.2712 0 925-414.7304 925-925.004 0-510.27344-414.7294-924.994094-925-924.994094zm0 100.000004c456.2276 0 825 368.76437 825 824.99409 0 456.2299-368.773 825.004-825 825.004-456.22712 0-825-368.7741-825-825.004 0-456.22972 368.77221-824.99409 825-824.99409zm-310.00586 434.96093v25.12696 754.9434h103.55469 412.71287 103.7442v-780.07036zm49.88672 50.07032h520.04684v679.91994h-53.666-412.71287-53.66797zm53.66797 76.54101v49.88477h412.71287v-49.88477zm0 150.60547v50.07813h412.71287v-50.07813zm0 174.03906v49.8945h412.71287v-49.8945zm0 157.2227v49.8964h412.71287v-49.8964z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartEventCondition);
export default __webpack_public_path__ + "static/media/start-event-condition.162901008ccfb84a00666e0de0f4fa57.svg";
export { ForwardRef as ReactComponent };